import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BasicBlankSlate from '../../_partials/BasicBlankSlate';

const ILLUSTRATION_SRC = Url.staticCDNLink(
  'eclipse/illustrations/boost-deviation.png'
);

const ShopReportsBlankSlate: FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <BasicBlankSlate
      illustrationSrc={ILLUSTRATION_SRC}
      title={t('studio.blankSlate.reports.title')}
      message={t('studio.blankSlate.reports.message', {
        postProcess: ['reactPostprocessor'],
        br: <br />,
      })}
    />
  );
};
ShopReportsBlankSlate.displayName = 'ShopReportsBlankSlate';

export default ShopReportsBlankSlate;
